import { enterpriseApiSlice } from "./index";
import { OrdersListResponse, OrderDetail } from "../Model/Api/OrdersObjects";

export const ordersApi = enterpriseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchCurrentOrders: builder.query({
      query: ({ page = 1, companyIds, status = [] } = {}) => {
        const params = new URLSearchParams({ page: String(page) });
        if (Array.isArray(companyIds) && companyIds.length > 0) {
          params.set("companyIds", companyIds.map((id) => Number(id)).join(","));
        }
        if (Array.isArray(status) && status.length > 0) {
          params.set("status", status.join(","));
        }
        return {
          url: `/orders/current?${params.toString()}`,
          method: "GET",
        };
      },
      extraOptions: { auth: true },
      providesTags: ["Orders"],
      transformResponse: (response) => new OrdersListResponse(response),
      keepUnusedDataFor: 30, // Cache for 30 seconds
    }),
    fetchOrderDetail: builder.query({
      query: ({ orderId, companyId }) => ({
        url: `/orders/${orderId}/?companyId=${companyId}`,
        method: "GET",
      }),
      extraOptions: { auth: true },
      providesTags: ["Orders"],
      transformResponse: (response) => new OrderDetail(response),
      keepUnusedDataFor: 0,
    }),
  }),
  overrideExisting: false,
});

export const {
  useFetchCurrentOrdersQuery,
  useFetchOrderDetailQuery,
} = ordersApi;
